import { Card, Select, Checkbox } from '@bancobarigui/barihaus';

interface InspectionType {
  value: string;
  label: string;
  disabled?: boolean;
}

interface ChecklistsFilterSectionProps {
  inspectionTypes: InspectionType[];
  selectedInspectionType: string | undefined;
  setSelectedInspectionType: (value: string | undefined) => void;
  showOnlyActive: boolean;
  setShowOnlyActive: (value: boolean) => void;
  loadingInspectionTypes?: boolean;
}

export function ChecklistsFilterSection({
  inspectionTypes,
  selectedInspectionType,
  setSelectedInspectionType,
  showOnlyActive,
  setShowOnlyActive,
  loadingInspectionTypes = false,
}: ChecklistsFilterSectionProps) {
  return (
    <Card className="mb-8">
      <style>{`
        .select-with-value .ant-select-arrow {
          display: none;
        }
        .select-with-value .ant-select-clear {
          opacity: 1;
          pointer-events: all;
        }
      `}</style>
      <div className="flex flex-col sm:flex-row items-start sm:items-end gap-4">
        <div className="w-full sm:w-64">
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            Tipo de Inspeção
          </label>
          <Select
            placeholder="Selecione"
            options={inspectionTypes as any}
            value={selectedInspectionType as any}
            onChange={(value) => {
              setSelectedInspectionType(value);
            }}
            onClear={() => {
              setSelectedInspectionType(undefined);
            }}
            className={`w-full ${selectedInspectionType ? 'select-with-value' : ''}`}
            allowClear
            loading={loadingInspectionTypes}
          />
        </div>

        <div className="flex items-center pb-0 sm:pb-1">
          <Checkbox
            checked={showOnlyActive}
            onChange={(e) => setShowOnlyActive(e.target.checked)}
          >
            <span className="text-sm font-normal text-gray-900 dark:text-gray-300 whitespace-nowrap">
              Somente vigente
            </span>
          </Checkbox>
        </div>
      </div>
    </Card>
  );
}
